angular.module('leanlaw').controller('CustomDetailReportCtrl', ['$scope', '$stateParams', '$q', '$rootScope', "alerts", 'userService', 'reportsService', 'lists', "exportJson", "singleRequest", "messageBus", function ($scope, $stateParams, $q, $rootScope, alerts, userService, reportsService, lists, exportJson, singleRequest, messageBus) {
  $scope.data = {};
  $scope.filter = {};
  var shortcuts = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'client.label';
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const term = $scope.me.terms.Custom1;
    const exp = $scope.data.filtered.map(client => ({
      Client: client.label,
      [term]: client.data.custom.custom1.average
    }));
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////

  async function activate() {
    // Note: even though we are not using 'me' it should still be loaded to ensure that
    // the lists are updated correctly (me() replaces certain terms in lists.matterRoles)
    $scope.me = await userService.me();
    const users = await userService.list();
    $scope.data.user = users.find(u => u.id === $stateParams.userId);
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      // if (payload.filter.range) filterClientEntries();
      filterEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  }
  async function filterEntries() {
    $scope.loading = true;

    // var query = angular.copy($scope.filter);
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "custom";
    query.primary = "clients";
    query.scopeAccount = $scope.data.user.id;
    query.scope = "primary";
    const report = await singleRequest.serviceCall("reports", reportsService.getReport)(query);
    if (!report) return;
    $scope.data.report = report;
    $scope.loading = false;
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("reports");
    deactivate();
  });
}]);